import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

function detectDeviceType(): string {
  const ua = navigator.userAgent;
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(ua)) return 'mobile';
  if (/Tablet|iPad/i.test(ua)) return 'tablet';
  return 'desktop';
}

function getSessionId(): string {
  const key = 'pv_session_id';
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
  }
  return id;
}

export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    // Skip admin routes
    if (location.pathname.startsWith('/admin')) return;
    // Avoid duplicate tracking for same path
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    const record = {
      path: location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      device_type: detectDeviceType(),
      session_id: getSessionId(),
    };

    supabase.from('page_views').insert(record).then(({ error }) => {
      if (error) console.error('Page tracking error:', error);
    });
  }, [location.pathname]);
}
